/* eslint-disable no-extra-boolean-cast */
import React from 'react';
import { Dropdown, Modal, Button, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import moment from 'moment';
import Calendar from 'react-calendar';
import { toastError } from '../../../../utils/toastMessage';
import ArrowBackIcon from '../../../../images/arrow-black.png';
import * as action from '../../../../actions/newYouslim';
import {
  CreateCourseBlock,
  CreateCourseTitle,
  GenerationModeBlock,
  GenerationModeLabel,
  ResultInfoBlock,
  ButtonBlock,
  Label,
} from './CreareCourseModalStyles';
import MenuStructureBlock from '../MenuStructureBlock';
import {
  proteinTagId,
  carbohydrateTagId,
  saladTagId,
  FruitTagId,
  vegetableTagId,
  defaultGenerationModes,
  defaultCourseDuration,
  fullStructureMenuTags,
  breakfastSnackId,
  lunchSnackId,
  dinnerSnackId,
} from '../../youslim2.0_Constants';

const CreateCourseModal = ({
  isOpen,
  onClose,
  user,
  trainingTemplate,
  getTrainingTemplate,
  createCourse,
  createCourseLoading,
}) => {
  const [isMorningSnack, setIsMorningSnack] = React.useState(true);
  const [isAfternoonSnack, setIsAfternoonSnack] = React.useState(true);
  const [isEveningSnack, setIsEveningSnack] = React.useState(false);
  const [choosedBreakfastTags, setChoosedBreakfastTags] = React.useState([
    proteinTagId,
    carbohydrateTagId,
    FruitTagId,
  ]);
  const [choosedLunchTags, setChoosedLunchTags] = React.useState([
    proteinTagId,
    carbohydrateTagId,
    vegetableTagId,
  ]);
  const [choosedDinnerTags, setChoosedDinnerTags] = React.useState([
    proteinTagId,
    carbohydrateTagId,
    saladTagId,
  ]);
  const [currentGenerationMode, setCurrentGenerationMode] = React.useState(1);
  const [currentDuration, setCurrentDuration] = React.useState(30);
  const [startComplexDate, setStartComplexDate] = React.useState(undefined);
  const [isOpenCollapse, setIsOpenCollapse] = React.useState(false);
  const [templateId, setTemplateId] = React.useState('');
  const [trainTemplateList, setTrainTemplateList] = React.useState([]);
  const [ffLimit, setFfLimit] = React.useState(0);

  React.useEffect(() => {
    getTrainingTemplate();
  }, []);

  React.useEffect(() => {
    const newTemplateArr = [];
    trainingTemplate.forEach((item) => {
      newTemplateArr.push({
        id: item.id,
        key: item.id,
        value: item.id,
        text: item.name,
      });
    });
    setTrainTemplateList([...newTemplateArr]);
  }, [trainingTemplate]);

  const selectTemplate = (data) => {
    setTemplateId(data.value);
  };

  const onClearData = () => {
    setIsMorningSnack(true);
    setIsAfternoonSnack(true);
    setIsEveningSnack(false);
    setChoosedBreakfastTags([proteinTagId, carbohydrateTagId, FruitTagId]);
    setChoosedLunchTags([proteinTagId, carbohydrateTagId, vegetableTagId]);
    setChoosedDinnerTags([proteinTagId, carbohydrateTagId, saladTagId]);
    setCurrentGenerationMode(1);
    setCurrentDuration(30);
    setStartComplexDate(undefined);
    setIsOpenCollapse(false);
    setTemplateId('');
    setTrainTemplateList([]);
    setFfLimit(0);
    onClose();
  };

  const onPressCreateCourse = React.useCallback(() => {
    const startDate = moment(startComplexDate).format('YYYY-MM-DD');
    const newChoosedBreakfastTags = [];
    const newChoosedLunchTags = [];
    const newChoosedDinnerTags = [];
    fullStructureMenuTags.forEach((currentTags) => {
      choosedBreakfastTags.forEach((id) => {
        if (currentTags === id) newChoosedBreakfastTags.push([id]);
      });
      choosedLunchTags.forEach((id) => {
        if (currentTags === id) newChoosedLunchTags.push([id]);
      });

      choosedDinnerTags.forEach((id) => {
        if (currentTags === id) newChoosedDinnerTags.push([id]);
      });
    });

    const menuStructure = {};

    if (!!newChoosedBreakfastTags) {
      menuStructure.breakfast = newChoosedBreakfastTags;
    }
    if (isMorningSnack) {
      menuStructure.morningSnack = [[breakfastSnackId]];
    }
    if (!!newChoosedLunchTags) {
      menuStructure.lunch = newChoosedLunchTags;
    }
    if (isAfternoonSnack) {
      menuStructure.afternoonSnack = [[lunchSnackId]];
    }
    if (!!newChoosedDinnerTags) {
      menuStructure.dinner = newChoosedDinnerTags;
    }
    if (isEveningSnack) {
      menuStructure.eveningSnack = [[dinnerSnackId]];
    }

    if (!startComplexDate) {
      toastError('Не выбрана дата старта');
      return;
    }
    if (!templateId) {
      toastError('Не выбран курс тренировок');
      return;
    }
    createCourse({
      user: user,
      start_date: startDate,
      duration: currentDuration,
      menu_structure: menuStructure,
      ff_limit: +ffLimit,
      repeat: currentGenerationMode,
      training_template_id: templateId,
      onClose: () => onClearData(),
    });
  }, [
    startComplexDate,
    currentDuration,
    ffLimit,
    currentGenerationMode,
    templateId,
    choosedBreakfastTags,
    choosedLunchTags,
    choosedDinnerTags,
  ]);

  return (
    <Modal
      style={{ alignSelf: 'center' }}
      open={isOpen}
      centered
      size="large"
      closeIcon
      onClose={onClose}
    >
      <Modal.Header style={{ textAlign: 'center' }}>
        <p>Создать новый курс</p>
      </Modal.Header>

      <Modal.Content>
        <CreateCourseBlock>
          <ResultInfoBlock onClick={() => setIsOpenCollapse(!isOpenCollapse)}>
            <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpenCollapse} />
            <CreateCourseTitle>Выбрать дату старта курса </CreateCourseTitle>
          </ResultInfoBlock>
          <Collapse isOpened={isOpenCollapse}>
            <Calendar
              minDate={new Date()}
              value={startComplexDate}
              onChange={setStartComplexDate}
            />
          </Collapse>
          <Label>Выбор курс тренировок</Label>
          <Dropdown
            openOnFocus
            fluid
            search
            selection
            options={trainTemplateList}
            placeholder="Выбрать Шаблон тренировки"
            value={templateId}
            onChange={(e, data) => selectTemplate(data)}
            style={{ width: '55%' }}
          />

          <MenuStructureBlock
            isMorningSnack={isMorningSnack}
            setIsMorningSnack={setIsMorningSnack}
            isAfternoonSnack={isAfternoonSnack}
            setIsAfternoonSnack={setIsAfternoonSnack}
            isEveningSnack={isEveningSnack}
            setIsEveningSnack={setIsEveningSnack}
            choosedBreakfastTags={choosedBreakfastTags}
            setChoosedBreakfastTags={setChoosedBreakfastTags}
            choosedLunchTags={choosedLunchTags}
            setChoosedLunchTags={setChoosedLunchTags}
            choosedDinnerTags={choosedDinnerTags}
            setChoosedDinnerTags={setChoosedDinnerTags}
            match={{ params: { user: 'admin' } }}
            isModal
          />

          <GenerationModeBlock>
            <GenerationModeLabel>Выбор режима генерации</GenerationModeLabel>
            <Dropdown
              placeholder="Выберите режим генерации"
              fluid
              value={currentGenerationMode}
              selection
              style={{ width: '60%' }}
              options={defaultGenerationModes}
              onChange={(e, data) => setCurrentGenerationMode(data.value)}
            />
          </GenerationModeBlock>
          <GenerationModeBlock>
            <GenerationModeLabel>Выбор длительность курса</GenerationModeLabel>
            <Dropdown
              placeholder="Выберите длительность курса"
              fluid
              value={currentDuration}
              selection
              style={{ width: '60%' }}
              options={defaultCourseDuration}
              onChange={(e, data) => setCurrentDuration(data.value)}
            />
          </GenerationModeBlock>
          <GenerationModeBlock>
            <GenerationModeLabel>Лимит фитнес функции</GenerationModeLabel>

            <Input
              placeholder="Введите лимит фф"
              type="number"
              style={{ width: '60%' }}
              value={ffLimit}
              onChange={(e) => setFfLimit(+e.target.value > 0 ? +e.target.value : 0)}
            />
          </GenerationModeBlock>
        </CreateCourseBlock>
        <ButtonBlock>
          <Button positive onClick={() => onPressCreateCourse()} loading={createCourseLoading}>
            Сгенерировать курc
          </Button>
          <Button onClick={onClose} disabled={createCourseLoading}>
            Отмена
          </Button>
        </ButtonBlock>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { trainingTemplate, createCourseLoading } = state.newYouslim;
  return {
    trainingTemplate,
    createCourseLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTrainingTemplate: () => {
      dispatch(action.getTrainingTemplate());
    },
    createCourse: ({
      user,
      start_date,
      duration,
      menu_structure,
      ff_limit,
      repeat,
      training_template_id,
      onClose,
    }) => {
      dispatch(
        action.createCourse({
          user,
          start_date,
          duration,
          menu_structure,
          ff_limit,
          repeat,
          training_template_id,
          onClose,
        }),
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateCourseModal);

const ImgArrow = styled.img`
  position: absolute;
  left: 15px;
  bottom: 10px;
  width: 30px;
  height: 30px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/CreateCourseModal/index.jsx